
import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ImagesDataFetcherService } from '@shared/services/image-feed/images-data-fetcher.service';
import { BehaviorSubject, delay, Observable } from 'rxjs';
import { Chunk, InfiniteScrollComponent } from '../infinite-scroll/infinite-scroll.component';

@UntilDestroy()
@Component({
    selector: 'image-feed',
    templateUrl: './image-feed.component.html',
    styleUrls: ['./image-feed.component.less']
})
export class ImageFeedComponent implements AfterViewInit {
    @Input() imageHeight: number;
    @Input() itemsPerRow: number;
    @Input() selectedPath?: string | null;
    @Input() selectedIndex?: number | null;

    @Output() imageClick = new EventEmitter<{ imageId?: number, itemPath?: string }>();
    @Output() imageSelect = new EventEmitter<any>();
    @ViewChild(InfiniteScrollComponent) viewport: InfiniteScrollComponent;

    loadingStatus$ = new BehaviorSubject<boolean>(false);

    constructor(
        public dataFetcher: ImagesDataFetcherService
    ) { }

    getChunk = (offset: number): Observable<Chunk> => {
        return this.dataFetcher.getChunk(offset);
    }

    getChunkSize(): number {
        return this.dataFetcher.CHUNK_SIZE;
    }

    ngAfterViewInit(): void {
        this.dataFetcher.dataRefetch$.pipe(
            delay(0), // don't reset viewport if change detection hasn't finished yet
            untilDestroyed(this)
        ).subscribe(_ => {
            this.viewport.reset();
        });

        this.dataFetcher.itemUpdate$.pipe(
            untilDestroyed(this)
        ).subscribe(item => {
            this.viewport.updateItem(item);
        });
    }
}
